import { useState } from "react";
import { Send, Plus, Loader2 } from "lucide-react";
import { PageHeader } from "../components/Layout";
import { Bubble, ChatSidebar, Suggerimenti, useChat } from "../components/Chat";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";

export default function Assistente() {
  const { sessions, sid, messages, loading, endRef, reset, open, remove, send } = useChat();
  const [input, setInput] = useState("");

  const submit = (text) => {
    const msg = (text ?? input).trim();
    if (!msg || loading) return;
    setInput("");
    send(msg);
  };

  return (
    <div>
      <PageHeader title="Assistente AI" subtitle="Domande su garanzie, Codice del Consumo e sui dati della concessionaria · Gemini 3 Flash">
        <Button variant="outline" onClick={reset} data-testid="chat-new-btn"><Plus className="mr-1 h-4 w-4" /> Nuova chat</Button>
      </PageHeader>
      <div className="grid gap-6 lg:grid-cols-[260px_1fr]">
        <ChatSidebar sessions={sessions} sid={sid} onOpen={open} onRemove={remove} />
        <section className="flex h-[calc(100vh-260px)] min-h-[480px] flex-col rounded-md border bg-slate-50/60">
          <div className="flex-1 space-y-4 overflow-y-auto p-5" data-testid="chat-messages">
            {messages.length === 0 && <Suggerimenti onPick={submit} />}
            {messages.map((m, i) => <Bubble key={m.id} m={m} i={i} />)}
            <div ref={endRef} />
          </div>
          <form onSubmit={(e) => { e.preventDefault(); submit(); }} className="flex gap-2 border-t bg-white p-3">
            <Textarea value={input} onChange={(e) => setInput(e.target.value)} rows={1} placeholder="Scrivi una domanda…" className="min-h-[44px] resize-none"
              onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); submit(); } }} data-testid="chat-input" />
            <Button type="submit" disabled={loading || !input.trim()} className="h-11 bg-[#B08D57] hover:bg-[#96764A]" data-testid="chat-send-btn">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
            </Button>
          </form>
        </section>
      </div>
      <p className="mt-3 text-xs text-muted-foreground">Le risposte dell'AI sono indicative e non sostituiscono una consulenza legale.</p>
    </div>
  );
}
